import React from 'react';
import { TextField, Typography, InputAdornment } from '@material-ui/core';
import { EditOutlined } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useBrandOutlinedFieldStyles } from './brandOutlinedFieldStyles';

const BrandNameInput = ({ isEditMode, brandName, handleBrandNameChange }) => {
  const classes = useBrandOutlinedFieldStyles();

  return (
    <div>
      <Typography>{`${
        isEditMode ? 'Modifica' : 'Inserisci'
      } nome del brand`}</Typography>
      <TextField
        className={classes.outlinedField}
        variant="outlined"
        value={brandName}
        onChange={handleBrandNameChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <EditOutlined />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

BrandNameInput.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  brandName: PropTypes.string.isRequired,
  handleBrandNameChange: PropTypes.func.isRequired,
};

export default BrandNameInput;
